export default __webpack_public_path__ + "static/media/creative_directions_l.27dd66e0.jpg";